import { DataSource } from "../../Data/DataSource";
import { Nullable, PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyString } from "../../RadObject";
import { LookupItemCache } from "../../Server/LookupItemCache";
import { CheckBoxTypeEnum } from "./CheckBox";
import { CheckBoxList, CheckBoxListPropertyValues, ICheckBoxList } from "./CheckBoxList";
import { NAMESPACE } from "./_Namespace";

export type CheckBoxListLookupItemPropertyValues =
    CheckBoxListPropertyValues
    & {
        lookupType: string;
        orderBy: "description" | "order";
    };

export type CheckBoxListLookupItemProperties = {
    [name in keyof CheckBoxListLookupItemPropertyValues]: Property<CheckBoxListLookupItemPropertyValues[name]>
};

export interface ICheckBoxListLookupItem extends ICheckBoxList, CheckBoxListLookupItemProperties
{
}

export class CheckBoxListLookupItem extends CheckBoxList implements ICheckBoxListLookupItem
{
    // #region Static

    public static override classNamespace = NAMESPACE + "CheckBoxListLookupItem";
    public static override className = "CheckBoxListLookupItem";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<CheckBoxListLookupItemPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                checkBoxType: CheckBoxTypeEnum.radio,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public lookupType!: PropertyString;
    public orderBy!: Property<"description" | "order">;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<CheckBoxListLookupItemPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Public Methods

    public async loadDataAsync()
    {
        const
            lookupType = this.lookupType.get(),
            orderBy = this.orderBy.get(),
            dataSourceProperty = this.dataSourceProperty.get(),
            dataSource = this.dataSource.get(),
            requiredId: Nullable<string> = (dataSourceProperty && dataSource ? dataSource.propertyValueByPathGet(dataSourceProperty) : null) ?? null,
            lookupItems = await LookupItemCache.getByTypeAsync(lookupType, requiredId, orderBy);

        this.listDataSource.set(new DataSource({ data: lookupItems.map(item => ({ value: item.id, description: item.description })) }));
        this.triggerHandler("listDataSourceChanged");
    }

    // #endregion

    // #region Protected Methods

    protected _lookupTypeChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }
    protected _orderByChanged(change: PropertyChange<"description" | "order">)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: CheckBoxListLookupItemPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.lookupType = new PropertyString(this, propertyValues.lookupType, this._lookupTypeChanged);
        this.orderBy = new Property<"description" | "order">(this, "System.String, System.Private.CoreLib", propertyValues.orderBy, this._orderByChanged);

        this.checkBoxType.overrideSet((value, next) =>
        {
            // Do nothing
        });
    }

    // #endregion

    // #endregion
}

